<template>
  <div class="transfer" style="width: 100%; background-color: #f1f1f1;">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()"/>
      </div>
      <span class="head_text">{{ $t('场馆转账') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="venuesTansfer">

      <div class="accounts-scroll">
        <div class="automatic">
          <div class="text">
            <div class="tit">{{ $t('余额自动转入') }}</div>
            <span>{{ $t('启用后余额自动转入转出游戏场馆') }}</span>
          </div>

          <van-switch @change="changeTasfer()" :active-value="1" :inactive-value="0"
                      v-model="$store.state.userInfo.transferstatus" size="18px" active-color="#ff8439"
                      inactive-color="#9ca3bf"/>
        </div>
        <div class="user-handle">
          <div :class="{'first-handle': true, 'reverse-row': transfer_type === 2}">
            <div class="item from" @click="changShow('sourcetype')">
              <span>{{ sourcetype.name }}</span>
              <img src="/static/image/new/arrow-white.png" class="arrowicon">
            </div>
            <img
              src="/static/image/new/mine/arrow-yellow.png"
              class="item icon" @click="reverseTransfer()">
            <div class="item to" @click="changShow('targettype')">
              <span>{{ targettype.name }}</span>
              <!--                <span>PC彩票</span>-->
              <img src="/static/image/new/arrow-white.png" class="arrowicon">
            </div>
          </div>
          <div class="second-handle">
            <div style="display: flex; align-items: center;">
<!--              <span class="currency">VND</span>-->
              <input type="number" inputmode="decimal" v-model="amount" :placeholder="$t('金额')" class="amount-input">
            </div>
            <span class="all-into" @click="bigMey">{{ $t('全部转入') }}</span>
          </div>
          <div class="bankbalance">
            {{ $t('可转账金额') }}
            <span class="number">{{ (transfer_type === 1 ? amount1 : targettype.balance) || '0.000' }}</span>
          </div>
          <div class="submit-btn" :class="{hasInput:amount}" @click="btnOk">{{ $t('确认转账') }}</div>
        </div>
        <div class="topArea">
          <div class="venuesDetail">
            <div class="venues">
              <div class="left-nums">{{ $t('场馆余额明细') }}</div>
              <span>{{ $t('点击查看全部场馆余额') }}</span><!---->

              <img v-show="show1" @click="show1=!show1"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAADm0lEQVRYR82Y209TWRSHf+sU09YEY8R/w0jivDCJMTwjXkZlGJ0LIOp4gdBCsVCKx0JpS6eFyNwQVHQ0IjoDsfhMMg+SSeYBM/+GMxkvsaD2LHNau+TINtbiTjxPPTl7r+/r7tk7v1XCJ3TRJ+SCd8o0nRnfhgocIqCWiXcA8JYvTk+I8YCBBbzE7akfT/yjqrVGpqnpiseoeh4GI8iAUb6AeiYBFoMT/J87MjXVvLx6lEPGFnFVvVhkoPpjS7xdj4Cl3L8balYLOWRaOydiTBx8M5EyBKQf5Z78dXvEny1XsKUlUWls2bKDYfkBqi/WIab4ZOpYj9wXP7T4f91uuFxLq4ChyeSxoXIF3jWvNTDRCyBafG7lctWX098/sO9lZY4HJqIgsgfa19zF4db9H1ukWO949+QsgH35e6ahi8mjIYfMie5L90GoKUzgXeOJ1j91yZwMTOy0DKNQn7E4Pnz0c4fMyeDlZ/x6+3pX/t84so535H1f4pAv7a1yb35WEKDsL/HmjQ6ZUz1XuFjk51iz9sNQxRPo6dBVkfkp+p12GRVPoG1910RmbPBb7TIqnkDbw7+JzIWBb7TLqHgC7Th3XWRGz3+tXUbFE6jPvCEyI+YR7TIqnkA7z98UmdS5rxwyneZ0Agb7wNjwvm275jnhBSxOpczDcuzbY1Q8gQYGpkUmGW50yAQGpu0zYR0RAtlkuDF/lhQvFU+g3YO3RGa470uHzNnBWwkmlL0yxJRK9DU4VkbFE2hwaEZk4r0N2t8ZFU+gPbE7IhPrOahdRsUTaCj+u8hEgwe0y6h4Ag0P/yEyA91faJdR8QTan5wVmUhgv3YZFU+g5g9zImN27dMuo+IJNJK++5iBynzecVdWmqdrn37wAVfiBF96xrsZntd5Btl+/x5nnomMZO4DhaRn5axdZtdebUkvkp7fCeJi/cV+X70z6Q2OztshOZ+BCTQX6qjTloGjo5lZBhUyMDDU17HbmYEjqcx2V4XxpjsgDobadydKXPmSh0UvzJ8FU7w4IUdWdX97vbM7yCuO3YuBSfomAjIMI+l5+fhvv7+h7L4pnZ7xLlds+oyIu5h5j5gTx3vb6tb2TfYA01zweLauLIJZe0cJoqXlh+4a06yVFnfNFraFvFtXTIAD0NBr2/sDoGT2odtcLeLoDt7+0eNj97YZ5GoEoRawV4rWESE4C9ASGAsW56aDbXWl/QtR8puoYaD2k/ZDnF8BLKVoM2MipTIAAAAASUVORK5CYII=">

              <img v-show="!show1" @click="show1=!show1"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAD1ElEQVRYR82Y709TVxjHv88trq0JixH/DSOJe8MSY3iNMNwUcT8p4u+V0EKxpRSPhdJeuhaUzYkwYL8yxG0Qi69J9kKyZC8w/hu6bLpYftj7mNvaI1fqcqi3iedVb3q+z/fTc+859/uU8BYNeotY8FqYti8n9qMKxwmoZ+KDANzlg9MTYtxnYBnPcHv267MPStXaBtPWNuPSajYiYAQZ0MoHKK0kwGCwzn87o7OznrWtsywwJoijZnOFgVq7IV6tR8Bq7tGuuq1AFpiO7sk4EwdfCilDQPrf3JM/b4/6s+UCtrfr1drevQcZhh+gxmIdYkpMpU6H5HXxQ7v/xgHN4VjdYhieSp4eLhfgdbqOwGQfgFjxeyOXq51On7tvXsuVOROYjIHInGiOxZsjHUftBinWO9M7tQCgOX/NNHwzeSpsgTnb+909EOoKAj48oXf8USmY84HJQ4amFeozViZGTr1vgTkfnH7KL7ave/2f3aOKz8i50LROTF4mXL0R98j7/38/5Lgv7a5x7nlaAKDstwnPbgvMhdAMFwtcj3uUD8MLoZkNALsAbF6Pe95RXc1SftL0Yvh7CfNN7AtlGDt10tTb/4OEGR/6XBnGTp007Yz8KGGuDX6mDGOnTpp2Xf5Jwoxd+VQZxk6dNPWJnyXMqPhEGcZOnTTtvvKLhEldPmmB6RZzOjT2gfO7ZmeDsAmDUynxsWXbl/KTpoHBOQmTjLRaYAKDc+aZ8AYRAtlkpDV/lhRHKT9p2jt0S8KM9J+wwFwauqUzoeyVIaaU3t9iWZlSftI0ODwvYRJ9LcrPjJ06aRqK/yph4qFjyjB26qRpOPGbhIkFP1KGsVMnTSMjv0uYwd4PlWHs1EnTgeSChIkGjirD2KmTpuKrRQkjepqVYURqcSN//hA2RXez8lu7lJ80jabvPGagOp93nNXV4mL9fyqnm0hldI3YawBXhb9JKc/40vPuPXC9yDPIDvibrHkmOpq5BxSSnpEzDoueDyqW9KLppUMgLtZfGfA1WpPe0NiSGZLzGZhAi+Guhopl4NhYZoFBhQwMDPd3HbFm4Ggqc8BRpb3sDoiD4c4jusqt2smc2LWlS2BKFDU5MmoHOhut3UEecfxuHEyybyIgw9CSrmeP//L7W8rum9Lpefda1bvvEXEPMzdJeOJEn7dhe99kThBi2eXat74C5op3lCBaXXvorBOiXra427awCeTety4ADqACvba5PwBKZh86xVYQS3fw6n1PjN/dr5GjFYR6wFwpeoMIwVmAVsFYNjg3F/Q2qP0LsZOH0e65yiet3cal6j0HzxOpM/w36wsAAAAASUVORK5CYII=">
            </div>
            <div class="venuesList" style="" v-show="show1">
              <div class="top">
                <div class="left">
                  <div class="left-top">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDY1MkYwMTE1RkM3MTFFQjhCMzVFOTc4QzhDMzM5QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDY1MkYwMTI1RkM3MTFFQjhCMzVFOTc4QzhDMzM5QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowNjUyRjAwRjVGQzcxMUVCOEIzNUU5NzhDOEMzMzlCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowNjUyRjAxMDVGQzcxMUVCOEIzNUU5NzhDOEMzMzlCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvYajyUAAADpSURBVHjaYqzuWMbDwMCwFojdGKgLdgBxKAsjI+MyGhgOAh4gh7MwMTJ6M9AOuLEwMjEy0dACBpAPGGhrARMTrS2gsQ+YSffBPyBOBeL1QPyFFkGkB8Q3gDgGiLWI8AFJQTQbiK8B8UkgNgbid0Asgt8HzCT5YDkQqwKxKZS+A8RLgTiKmnHwC0r/p0UkRwJxOhCfBuJbQPwGiMWoGUSg1DMRiC2BOBgaD1SNZBC4hJRM19MimYI0zIVimmS0QVZU0L6wY2T8Bw1XWoB/oApnK5DhSyMLtoJ8AMrm64DYlcqG7wYVIQABBgABvyLx/uNgawAAAABJRU5ErkJggg==">
                    <span class="main-number">{{ $t('主钱包') }}</span>
                  </div>
                  <span class="money">
<!--                    <span>VND</span> -->
                    {{ amount1 }}</span>
                </div>
                <div class="btn-box" @click="transall()">{{ $t('一键取回') }}</div>
              </div>

              <div class="gameBox" v-if="balancelist.length">
                <div class="lis" v-for="(item, index) in balancelist" v-if="index < showLis" :key="index">
                  <div class="name">{{ item.name }}</div>
                  <div class="num">{{ item.balance }}</div>
                </div>
                <div class="lis" v-if="showLis != 4" @click="changShowLis(4)">
                  <div class="name">{{ $t('收起') }}</div>
                  <div class="num"><img src="/static/image/xiangshang.png" alt=""/></div>
                </div>
                <div class="lis" v-if="showLis == 4" @click="changShowLis(balancelist.length )">
                  <div class="name">{{ $t('展开') }}</div>
                  <div class="num"><img src="/static/image/xiangxia.png" alt=""/></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :columns="balancelist"
        value-key="name"
        @confirm="selectBalance"
        :default-index="balanceIndex"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'transfer',
  data() {
    return {
      show1: false,
      nshow: true,
      balancelist: [],
      balanceIndex: 0,

      openInfo: {},
      amount: null,
      payType: 0,
      openShow: false,
      daoTime: null,
      showLis: 4,
      show: false,
      type: 'sourcetype',
      sourcetype: {platname: 'userbalance', name: this.$t('平台钱包')},

      targettype: {},

      transfer_type: 1,  // 转入类型   1- 平台钱包-其他钱包  2-其他钱包-平台钱包
    };
  },
  created() {
    let that = this;
    that.getbalancelist();
    // that.daoTime = setInterval(() => {
    //   that.getbalancelistNoLoding();
    // }, 1500);
    // console.log(this.amount1,' 看看我')
  },
  computed: {
    amount1() {
      return this.$store.state.userInfo.balance + this.$store.state.userInfo.gameblance
    }
  },
  watch: {
    amount1(newVal) {
      this.sourcetype.balance = newVal;
    }
  },
  methods: {
    bigMey() {
      let that = this;
      // if(that.sourcetype.platname == 'userbalance'){
      //   that.amount = that.$store.state.userInfo.balance
      // }else{
      //   that.amount = that.sourcetype.balance*1

      // }
      if (this.transfer_type === 1) {
        this.amount = this.amount1
      } else {
        this.amount = this.targettype.balance || "0.000"
      }
    },
    // 反转转入类型
    reverseTransfer() {
      this.transfer_type = (this.transfer_type === 1 ? 2 : 1)
      this.amount = ''
    },
    changShow(name) {
      this.type = name;
      if (name === 'targettype') {
        this.show = true;
      }

    },
    changApiType(name, val) {
      let that = this;
      that[name] = val;
      that.show = false;
      if (name == 'sourcetype') {
        that.amount = null;

      }
    },
    changShowLis(val) {
      this.showLis = val;
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    btnOk() {
      let that = this;
      if (!this.amount) return
      if (that.amount == null || that.amount == '') {
        that.$parent.showTost(0, that.$t('请输入操作金额') + '！');
        return;
      }
      if (that.sourcetype.platname != 'userbalance' && that.targettype.platname != 'userbalance') {
        that.$parent.showTost(0, that.$t('场馆内钱包不支持互转'));

        return
      }
      let info = {
        amount: that.amount,
        sourcetype: this.transfer_type === 1 ? that.sourcetype.platname : that.targettype.platname,
        targettype: this.transfer_type === 1 ? that.targettype.platname : that.sourcetype.platname,
      };

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      }).catch(res => {
        that.$parent.hideLoading();
      });
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = {amount: that.amount, sourcetype: sourcetype, targettype: targettype};
      if (that.amount == null) {
        that.$parent.showTost(0, that.$t('请输入操作金额') + '！');
        return;
      }
      that.closeCv();

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
      that.openShow = false;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
    changeTasfer() {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', {transferstatus: mianzhuan})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.$parent.showTost(1, that.$t('操作成功') + '！');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changVal(item) {
      let that = this;
      // $store.state.userInfo.transferstatus == 0  0  转账模式  1免转模式
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.openShow = true;
      that.amount = null;
    },
    close() {
      that.openInfo = {};
      that.openShow = false;
      that.amount = null;
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(async (res) => {
          that.$parent.hideLoading();
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            // that.balancelist = res.data;
            let balancelist = res.data;
            // balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });

            const arr = await translateText([balancelist[0].name]);
            balancelist[0].name = arr[0]
            that.balancelist = balancelist;
            // that.targettype = balancelist[this.balanceIndex];
            that.targettype = balancelist[0];
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    // 切换余额类型
    selectBalance(item, index) {

      this.balanceIndex = index
      if (this.type === 'targettype') {
        this.targettype = item
      }
      this.show = false
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(async (res) => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            // that.balancelist = res.data;
            let balancelist = res.data;
            const arr = await translateText([balancelist[0].name]);
            balancelist[0].name = arr[0]
            // balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = [balancelist[0]];
          }
        })
        .catch(res => {
        });
    },

    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.transfer {
  height: 100vh;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;

    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }

    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }

    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 45%;
      text-align: center;
    }

    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }

  .venuesTansfer {
    flex: 1;
    overflow: auto;
  }

  .van-switch--on {
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8) !important;
    border-color: #4B5BF1 !important;
  }
}

.gameBox {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;

  .lis {
    width: 25%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0.27rem;

    .name {
      font-size: 0.32rem;
      line-height: 1;
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //显示省略号
      white-space: nowrap; //强制不换行
    }

    .num {
      font-size: 0.32rem;
      color: #737373;
      margin-top: 0.16rem;
    }

    img {
      width: 0.32rem;
    }
  }
}

.card {
  .lis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    height: 1.2rem;
    border-bottom: 1px solid #f8f8f8;

    img {
      width: 0.4rem;
    }
  }
}

.mianzhuan {
  display: flex;
  height: 2rem;
  align-items: center;
  margin: 14px auto;
  box-sizing: border-box;
  padding: 0 20px;
  background: #fff;

  .lfs {
    flex: 1;
    font-weight: 700;
    font-size: 0.4rem;
  }

  .ces {
    color: #a5a9b3;
    padding-right: 10px;
    font-size: 0.3rem;
  }
}


.venuesTansfer {
  .head {
    width: 100%;
    height: 1.17333rem;
    border-bottom: .02667rem solid #f4f4f4;
    background: #fff;

    img {
      width: .64rem;
      height: .64rem;
      margin-left: .13333rem;
      margin-top: .26667rem
    }

    .head-text {
      margin-left: 3.33333rem;
      font-size: .45333rem;
      color: #424653;
      font-weight: 700
    }
  }

  .accounts-scroll {
    padding: 0 .4rem;

    .automatic {
      width: 9.2rem;
      height: 2rem;
      border-radius: .19rem;
      margin-bottom: .27rem;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: .43rem .27rem;

      .text {
        color: #bbb;
        font-size: .32rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .tit {
          font-size: .37rem;
          color: #fff;
        }

        span {
          font-size: .26667rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #9ca3bf;
          margin-top: .13333rem
        }

        .Popovershow {
          width: .32rem;
          height: .32rem;
          margin-left: .05333rem;
          -webkit-transform: translateY(.02667rem);
          -ms-transform: translateY(.02667rem);
          transform: translateY(.02667rem)
        }
      }

      .desShow {
        margin-top: .08rem;
        min-width: 3.2rem;
        max-width: 11.2rem;
        background-color: #424653;
        position: absolute;
        border-radius: .16rem;
        padding-left: .16rem;
        padding-right: .16rem;
        padding-top: .08rem;
        padding-bottom: .08rem;
        line-height: .48rem;
        margin-left: 0;
        z-index: 999;
        border: .02667rem solid #ccc;
        font-size: .26667rem;
        margin-right: 0;
        box-sizing: border-box;
        color: #fff
      }
    }

    .user-handle {
      width: 9.2rem;

      .first-handle {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 1.44rem;
        border: .03rem solid rgba(255, 255, 255, 0.10);
        background: rgba(255, 255, 255, 0.10);
        border-radius: .19rem;

        .from, .to {
          max-width: 4.26667rem;
          cursor: pointer
        }

        .item {
          display: flex;
          height: 1.33333rem;
          justify-content: center;
          align-items: center;

          span {
            font-size: .37rem;
            margin-right: .26667rem;
          }

          .arrowicon {
            width: .5rem;
          }

        }

        .icon {
          width: .8rem;
          height: .8rem;
          margin-top: .12rem;
        }
      }

      .reverse-row {
        flex-direction: row-reverse;
      }

      .second-handle {
        height: 1.44rem;
        border: .03rem solid rgba(255, 255, 255, 0.10);
        background: rgba(255, 255, 255, 0.10);
        border-radius: .19rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .53rem 0 .91rem;
        margin-top: .27rem;

        .currency {
          font-size: 0.32rem;
          color: #BBBBBB;
          margin-right: .53rem;
        }

        .amount-input {
          color: #FFFFFF;
          outline: none;
          border: none;
          background: transparent;

          &::-webkit-input-placeholder {
            //color: #fff;
          }
        }

        .all-into {
          font-size: 0.32rem;
          color: #E20B00;
        }

        .van-cell:after {
          content: none !important
        }
      }

      .bankbalance {
        margin-top: .4rem;
        display: flex;
        align-items: center;
        font-size: .32rem;
        color: #BBBBBB;

        .number {
          color: #6675FF;
          font-size: .43rem;
          margin-left: .21rem;
        }
      }

      .submit-btn {
        background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
        height: 1.17rem;
        border-radius: .6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.43rem;
        font-weight: bold;
        margin-top: 1.07rem;
        opacity: .5;

        &.hasInput {
          opacity: 1;
        }
      }
    }

    .lastbutton {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 8rem;
      height: 1.2rem;
      background: linear-gradient(90deg, #ff8846, #ffbe61);
      border-radius: .61333rem;
      opacity: .4;
      font-size: .42667rem;
      font-weight: 700;
      color: #fff;
      margin: 0 auto;
      margin-top: .37333rem
    }
  }
}


.venuesTansfer .accounts-scroll .user-handle .hasInput {
  opacity: 1 !important
}

.venuesTansfer .accounts-scroll .topArea {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.19rem 0.19rem 0.19rem 0.19rem;
  border: 0.03rem solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding-top: .13333rem;
  min-height: auto !important;
  margin-top: .53rem;
}

.venuesTansfer .van-popup {
  min-height: 8rem;
  padding-top: .26667rem;
  padding-bottom: .66667rem
}

.venuesTansfer .van-popup .van-action-sheet__item {
  padding-top: 0;
  padding-bottom: 0;
  height: 1.33333rem;
  border-bottom: .02667rem solid #f2f3f5
}

.actionSheetPop {
  width: 6.93333rem;
  max-height: 10rem;
  overflow: scroll;
  background: #fff;
  border-radius: .26667rem
}

.actionSheetPop .actionItem {
  width: 6.93333rem;
  height: 1.33333rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: .4rem;
  padding-right: .4rem;
  border-bottom: .02667rem solid #e1e1e1
}

.actionSheetPop .actionItem,
.actionSheetPop .actionItem .left {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.actionSheetPop .actionItem .left {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

.actionSheetPop .actionItem .left .game {
  font-size: .37333rem;
  font-family: DIN;
  font-weight: 500;
  color: #424653
}

.actionSheetPop .actionItem .left .hot {
  width: .69333rem;
  height: .34667rem;
  margin-left: .4rem
}

.actionSheetPop .actionItem .right {
  width: .45333rem;
  height: .4rem
}

.actionSheetPop::-webkit-scrollbar {
  display: none !important
}

.venuesDetail .Popovershow {
  width: .26667rem;
  height: .26667rem
}

.venuesDetail .venues {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: .32rem;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang-SC-Medium;
  font-size: .32rem;
  padding: 0 .27rem .36rem;
}

.venuesDetail .venues .left-nums {
  font-size: 0.37rem;
}

.venuesDetail .venues span {
  font-size: 0.27rem;
  flex: 1;
  text-align: right;
  color: #BBBBBB;
}

.venuesDetail .venues img {
  width: .46667rem;
  height: .46667rem;
  margin-left: .24rem
}

.venuesDetail .venues .disable {
  pointer-events: none
}

.venuesDetail .venuesList {
  padding: 0 .27rem;
}

.venuesDetail .venuesList .top {
  display: flex;
  height: 1.68rem;
  background: #010101;
  border-radius: .16rem;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: .27rem;
}

.venuesDetail .venuesList .top .left {
  width: 4.8rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.venuesDetail .venuesList .top .left .left-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.venuesDetail .venuesList .top .left .left-top img {
  width: .34rem;
  margin-right: .16rem;
  vertical-align: middle;
}

.venuesDetail .venuesList .top .left .left-top .main-number {
  font-size: .27rem;
}

.venuesDetail .venuesList .top .left .money {
  font-family: Gilroy;
  font-size: 0.43rem;
  color: #6675FF;
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.venuesDetail .venuesList .top .left .money span {
  font-family: PingFang SC, PingFang SC;
  font-size: 0.27rem;
  color: #BBBBBB;
  margin-right: .16rem;
}

.venuesDetail .venuesList .top .btn-box {
  align-items: center;
  display: flex;
  height: .75rem;
  padding: 0 .32rem;
  background: radial-gradient(70% 70% at -1% 100%, #828CE2 0%, #1D2458 100%), #1B1D34;
  border-radius: 0.14rem;
  border: 0.02rem solid #828CE2;
  font-size: 0.29rem;
  color: #B0B0FF;
}


.venuesDetail .venuesList .listbox {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  padding-left: .32rem;
  padding-right: .32rem
}

.venuesDetail .venuesList .listbox .item {
  width: 25%;
  height: 2rem;
  border-bottom: .02667rem solid #eee
}

.venuesDetail .venuesList .listbox .item,
.venuesDetail .venuesList .listbox .item .inner-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.venuesDetail .venuesList .listbox .item .inner-box {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-right: .02667rem solid #eee;
  width: 100%;
  padding-left: .08rem;
  padding-right: .08rem
}

.venuesDetail .venuesList .listbox .item .inner-box .out {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.venuesDetail .venuesList .listbox .item .inner-box .out .tittleText {
  font-size: .29333rem;
  font-family: PingFang SC;
  color: #424653;
  max-height: 1.2rem;
  line-height: .4rem;
  overflow: hidden;
  word-break: break-all
}

.venuesDetail .venuesList .listbox .item .inner-box .out img {
  margin-left: .05333rem
}

.venuesDetail .venuesList .listbox .item .inner-box .moneyText {
  margin-top: .18667rem;
  font-size: .29333rem;
  font-family: DIN;
  font-weight: 500;
  color: #7e88ad
}

.venuesDetail .venuesList .listbox .item .inner-box .blue {
  color: #68a6f7
}

.venuesDetail .venuesList .listbox .item .desShow {
  min-width: 3.2rem;
  max-width: 3.73333rem;
  background-color: #424653;
  position: absolute;
  margin-bottom: 2.4rem;
  border-radius: .16rem;
  padding-left: .16rem;
  padding-right: .16rem;
  padding-top: .08rem;
  padding-bottom: .08rem;
  line-height: .48rem;
  margin-left: 1.06667rem;
  z-index: 999;
  border: .02667rem solid #ccc;
  font-size: .26667rem;
  margin-right: .4rem;
  box-sizing: border-box;
  color: #fff
}

.venuesDetail .venuesList .listbox .bbNone {
  border-bottom: none !important
}

.venuesDetail .venuesList .listbox .item:nth-child(4n) .inner-box {
  border-right: none
}


</style>



// WEBPACK FOOTER //
// src/components/transfer.vue